import React from 'react';
import Icon from '../../../components/AppIcon';

const SectionHeader = ({ section, isActive, isCompleted }) => {
  const getStatusIcon = () => {
    if (isCompleted) {
      return <Icon name="CheckCircle" size={24} color="var(--color-success)" />;
    } else if (isActive) {
      return <Icon name="Circle" size={24} color="var(--color-secondary)" />;
    } else {
      return <Icon name="Circle" size={24} color="var(--color-muted-foreground)" />;
    }
  };

  const getStatusColor = () => {
    if (isCompleted) return 'text-success';
    if (isActive) return 'text-secondary';
    return 'text-muted-foreground';
  };

  return (
    <div className={`bg-white rounded-lg shadow-subtle p-4 sm:p-6 mb-4 sm:mb-6 transition-all duration-300 ${
      isActive ? 'ring-2 ring-secondary ring-opacity-20' : ''
    }`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 sm:space-x-4">
        <div className="flex-shrink-0 hidden sm:block">
          {getStatusIcon()}
        </div>
        <div className="flex-1">
          <div className="flex items-center space-x-2 sm:space-x-3 mb-2">
            <Icon name={section?.icon} size={18} className={`${getStatusColor()} sm:w-5 sm:h-5`} />
            <h3 className={`text-lg sm:text-xl font-semibold ${getStatusColor()} flex-1`}>
              {section?.title}
            </h3>
            <div className="sm:hidden flex-shrink-0">
              <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                isCompleted 
                  ? 'bg-success/10 text-success' 
                  : isActive 
                    ? 'bg-secondary/10 text-secondary' :'bg-surface text-muted-foreground'
              }`}>
                {isCompleted ? 'Complete' : isActive ? 'In Progress' : 'Pending'}
              </div>
            </div>
          </div>
          <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed">
            {section?.description}
          </p>
        </div>
        <div className="hidden sm:block flex-shrink-0">
          <div className={`px-3 py-1 rounded-full text-xs font-medium ${
            isCompleted 
              ? 'bg-success/10 text-success' 
              : isActive 
                ? 'bg-secondary/10 text-secondary' :'bg-surface text-muted-foreground'
          }`}>
            {isCompleted ? 'Complete' : isActive ? 'In Progress' : 'Pending'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;